import { gql } from "graphql-request"

const binance = {
    name: 'binance',
    title: 'Binance DEX',
    currency: 'BNB',
    check: true,
    regexp: '([\\W]|^)(bnb[0-9a-z]{39})([\\W]|$)',
    noregxp: [
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],
    query: gql`query ($address: String!) {
        binance {
            ins: transfers(receiver: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyIn: transfers(receiver: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
            outs: transfers(sender: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyOut: transfers(sender: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
        }
    }`,
    checkAddress: 'bnb1jstexazk7zateuwzzwllswu4j3dsllu3dgte4m',
}
export { binance }
